import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        // CRITICAL: If returning from the Google OAuth callback, skip the /me check.
        // AuthCallback exchanges the session_id and establishes the session first.
        if (window.location.hash?.includes("session_id=")) {
            setUser(null);
            return;
        }
        if (!localStorage.getItem("lakou_token")) {
            setUser(null);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("lakou_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const loginWithGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const completeGoogleLogin = (token, userData) => {
        localStorage.setItem("lakou_token", token);
        setUser(userData);
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("lakou_token");
        setUser(null);
    };

    return <AuthContext.Provider value={{ user, login, loginWithGoogle, completeGoogleLogin, logout, loading: user === undefined }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
